import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import Animations from "../../components/animation/Animation";
import App from "../../App";
import PrivateRouteAdmin from "../PrivateRouteAdmin";
import PublicRoute from "../PublicRoute";

const PainelAdministrativo = lazy(() => import('../../pages/admin/painelAdministrativo/PainelAdministrativo'));
const Login = lazy(() => import('../../pages/admin/login/Login'));
const Home = lazy(() => import('../../pages/admin/home/Home'));
const CadastrarEmpresa = lazy(() => import('../../pages/admin/empresa/cadastrarEmpresa/CadastrarEmpresa'));
const EditarEmpresa = lazy(() => import('../../pages/admin/empresa/editarEmpresa/EditarEmpresa'));

const rotasAdmin = createBrowserRouter([
    {
        id: 'app-admin',
        path: '/',
        element: <App />,
        children: [
            {
                id: 'admin',
                path: '/admin',
                element: (
                    <Suspense fallback={<Animations />}>
                        <PainelAdministrativo />
                    </Suspense>
                ), 
                children: [
                    {
                        id: 'admin-login',
                        path: '',
                        element: (
                            <Suspense fallback={<Animations />}>
                                <PublicRoute>
                                    <Login />
                                </PublicRoute>
                            </Suspense>
                        ),
                    },
                    {
                        id: 'admin-home',
                        path: 'home',
                        element: (
                            <Suspense fallback={<Animations />}>
                                <PrivateRouteAdmin>
                                    <Home />
                                </PrivateRouteAdmin>
                            </Suspense>
                        )
                    },
                    {
                        id: 'admin-cadastrar-empresa',
                        path: 'cadastrar-empresa',
                        element: (
                            <Suspense fallback={<Animations />}>
                                <PrivateRouteAdmin>
                                    <CadastrarEmpresa />
                                </PrivateRouteAdmin>
                            </Suspense>
                        )
                    }, 
                    {
                        id: 'admin-editar-empresa',
                        path: 'editar-empresa',
                        element: (
                            <Suspense fallback={<Animations />}>
                                <PrivateRouteAdmin>
                                    <EditarEmpresa />
                                </PrivateRouteAdmin>
                            </Suspense>
                        )
                    }
                ]
            },
        ]
    }
]);

export default rotasAdmin;